import { sendAnalyticsTrack } from 'Utils/analytics.utils'
import { ActionConfig, ActionContext, IAction } from '../Action'
import { NotificationPropsType } from 'Types/Tasks.types'

export class ExitAction implements IAction {
    static Id = 'Exit' as const
    constructor(
        private actionContext: ActionContext,
        private config?: ActionConfig
    ) {
        this.addToWorkbench()
    }

    addToWorkbench(): void {
        this.actionContext.workbenchUiAccessor?.toolbar.addAction(
            {
                id: 'exit',
                title: this.config?.title ?? 'Exit',
                type: 'button',
                onClick:
                    this.config?.onClick ??
                    (async () => {
                        const errorAndWarningCount =
                            this.actionContext.studio.inputManager.getErrorAndWarningCount()
                        sendAnalyticsTrack('ExitCTA_Clicked', {
                            ...this.actionContext.task.getCommonAnalyticsObject(),
                            duration_since_task_start: Math.floor(
                                this.actionContext.studio.taskManager.timer.getElapsedTime() / 1000
                            ),
                            warning_count: errorAndWarningCount.warningCount,
                            error_count: errorAndWarningCount.errorCount,
                        })
                        await this.actionContext.task.saveTask(true, {
                            onComplete: (notifications?: NotificationPropsType) =>
                                this.actionContext.studio.exitTask(notifications),
                        })
                    }),
                color: 'default',
                disabled: this.config?.disabled ?? false,
                tooltip: this.config?.tooltip,
            },
            this.config?.placement
        )
    }

    removeFromWorkbench(): void {
        this.actionContext.workbenchUiAccessor?.toolbar.removeAction('exit')
    }
}
